"use strict";

exports.__esModule = true;
exports.dataHooks = exports.TIMEOUT = exports.SIZES = void 0;
var dataHooks = {
  tooltipText: 'tooltip-text'
};
exports.dataHooks = dataHooks;
var TIMEOUT = {
  enter: 100,
  exit: 150
};
exports.TIMEOUT = TIMEOUT;
var SIZES = {
  small: 'small',
  medium: 'medium'
};
exports.SIZES = SIZES;
//# sourceMappingURL=constants.js.map